import * as actionTypes from '../types/waste';

export function getWasteRolls(payload) {
  return {
    type: actionTypes.GET_WASTE_ROLLS,
    payload
  };
}

export function getWasteRollsSuccess(payload) {
  return {
    type: actionTypes.GET_WASTE_ROLLS_SUCCESS,
    payload
  };
}

export function getWasteRollsFail(payload) {
  return {
    type: actionTypes.GET_WASTE_ROLLS_FAIL,
    payload
  };
}
